




import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';

import pACSR from '../assest/product image cropped/01_ACSR_Conductors.png.png';
import pAAAC from '../assest/product image cropped/02_AAAC_Conductors.png.png';
import pAAC from '../assest/product image cropped/03_AAC_Conductors.png.png';
import pACAR from '../assest/product image cropped/04_ACAR_Conductors.png.png';
import pAL59 from '../assest/product image cropped/05_AL59_Conductors.png.png';


   import pGI7 from '../assest/v crosss.jpg';
  import pGI1 from '../assest/GI Products/clamps.jpg';
import pGI2 from '../assest/GI Products/DT Structure (Distribution Transformer Structure).jpg';
import pGI3 from '../assest/GI Products/Earthing System.png';
import pGI4 from '../assest/GI Products/Galvanized steel cross support.png';
import pGI5 from '../assest/GI Products/Line DP Structure (Double Pole Structure).jpg';
import pGI6 from '../assest/GI Products/stay set.jpg';
import Angle from '../assest/GI Products/ANGLE.png';
import pGIVCross from '../assest/GI Products/v crosss.jpg';
import Channel from '../assest/GI Products/CHANNLE.png';
import Flat from '../assest/Hardware Fittings.png';






import pXLPE1 from '../assest/product image cropped/XLPE_Insulated_Armoured_Cable.png.png';
import pXLPE2 from '../assest/product image cropped/XLPE_Insulated_Armoured_Cable_2.png.png';
import pMVXLPE from '../assest/product image cropped/MV_XLPE_Insulated_Armoured_Cable.png.png';
import pPVC from '../assest/product image cropped/PVC_Insulated_Armoured_Cable.png.png';

import p11kVPolymerPin from '../assest/product image cropped/11kV_Polymer_Pin_Insulator_5kN_Strength.png.png';
import p33kVPorcelainPinGI from '../assest/product image cropped/33kV_Porcelain_Pin_Insulator_with_GI_Pin.png.png';
import p11kVPolymericDisc from '../assest/product image cropped/11kV_Polymeric_Disc_Insulator.png.png';
import p33kVPorcelainDisc from '../assest/product image cropped/33kV_Porcelain_Type_Disc_Insulator.png.png';
import p11kVPolymericLA from '../assest/product image cropped/11kV_Polymeric_Type_Lightning_Arrester.png.png';

import pSteelPole from '../assest/product image cropped/PCS.png';
import pConcretePole from '../assest/product image cropped/RS NEW.png';
import pRailPole from '../assest/NEW RA.png';
import pJoist from '../assest/product image cropped/OCTANGLE.png';
import pAL511 from '../assest/product image cropped/TABULAR.png';

const categories = [
  {
    index: '01',
    tag: 'Conductors',
    title: 'CONDUCTORS',
    description:
      'Specialized electrical conductors engineered to carry maximum current at various voltage levels, across tough terrains — for improved efficiency and reduced power losses.',
    stats: [
      { label: 'Voltage Range (kV)', value: '11 – 33' },
      { label: 'Conductor Types', value: '5+' },
    ],
    images: [pACSR, pAAAC, pAAC, pACAR, pAL59],
    href: '/products#electrical-conductors',
  },
   {
    index: '05',
    tag: 'GI Products',
    title: 'ALL TYPES OF ELECTRICAL GI FABRICATION',
    description:
  'Complete GI fabrication solutions for power transmission and distribution, including GI V Cross, Stay Sets, Line Clamps, DT Structures, DP Structures, and Earthing Systems. Built with premium galvanized steel for maximum durability, corrosion resistance, and reliable field performance.',
    stats: [
      { label: 'Fabrication Types', value: '11+' },
      { label: 'Build', value: 'Hot-Dip Galvanized' },
    ],
    images: [pGI1, pGI2, pGI3, pGI4,pGI7,pGI5,pGI6,Angle,pGIVCross,Channel,Flat],
    href: '/products#gi-products',
  },

  {
    index: '02',
    tag: 'Cables',
    title: 'ARMOURED CABLES',
    description:
      'XLPE, MV XLPE and PVC insulated armoured cables built for safe, long-lasting power transmission — engineered for both underground and above-ground runs.',
    stats: [
      { label: 'Insulation Types', value: '3' },
      { label: 'Voltage Range (kV)', value: 'Up to 33' },
    ],
    images: [pXLPE1, pMVXLPE, pXLPE2, pPVC],
    href: '/products#insulated-armoured-cables',
  },
  {
    index: '03',
    tag: 'Insulators & Protection',
    title: 'INSULATORS & ARRESTERS',
    description:
      'High performance pin, disc insulators and lightning arresters designed for durability, safety and reliable protection against surges on the line.',
    stats: [
      { label: 'Voltage Range (kV)', value: '11 – 33' },
      { label: 'Product Variants', value: '10+' },
    ],
    images: [p11kVPolymerPin, p33kVPorcelainPinGI, p11kVPolymericDisc, p33kVPorcelainDisc, p11kVPolymericLA],
    href: '/products#pin-insulators',
  },
  {
    index: '04',
    tag: 'Structures',
    title: 'ALL TYPES OF ELECTRIC POLES',
    description:
      'PSC, Rail, Tubular, Octagonal and RSJ poles fabricated to spec — strong, weather-ready supports engineered for decades of outdoor service.',
    stats: [
      { label: 'Structure Types', value: '5' },
      { label: 'Build', value: 'Corrosion Resistant' },
    ],
    images: [pSteelPole, pConcretePole, pRailPole, pJoist,pAL511],
    href: '/products#tower-pole-support',
  },
];

/** Re-triggering staggered slide-up wrapper — animates in every time it enters view */
/** Slide-up wrapper — animates in ONCE when it first enters view, then stays visible (no re-trigger/blink on scroll) */
function StaggerItem({ children, index = 0, className = '' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el); // once shown, stop watching — prevents blinking on further scroll
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`transition-all ease-out ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      } ${className}`}
      style={{ transitionDuration: '600ms', transitionDelay: visible ? `${index * 100}ms` : '0ms' }}
    >
      {children}
    </div>
  );
}

function ImageTile({ src, alt }) {
  return (
    <div className="h-64 w-40 shrink-0 rounded-2xl bg-white p-4 sm:h-72 sm:w-48 sm:p-5 md:h-80 md:w-52">
      <img
        src={src}
        alt={alt}
        className="h-full w-full object-contain object-center transition duration-500 ease-out hover:scale-105"
        loading="lazy"
      />
    </div>
  );
}

function CategoryRow({ cat }) {
  return (
    <div className="relative mx-auto mb-6 max-w-7xl overflow-hidden rounded-[2rem] bg-slate-200 px-4 py-14 sm:px-8 sm:py-16 lg:py-20">
      {/* ---------------- CENTERED COPY ---------------- */}
      <div className="relative mx-auto max-w-3xl text-center">
        <StaggerItem index={0}>
          <span className="text-xs font-bold tracking-widest text-slate-400">{cat.index}</span>
        </StaggerItem>

        <StaggerItem index={1}>
          <h2 className="text-2xl font-extrabold uppercase leading-none sm:text-3xl lg:text-4xl">
            {cat.title}
          </h2>
        </StaggerItem>

        <StaggerItem index={2}>
          <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
            {cat.description}
          </p>
        </StaggerItem>

        <StaggerItem index={3}>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {cat.stats.map((s) => (
              <div key={s.label}>
                <p className="text-xs font-bold uppercase tracking-wide text-slate-400">{s.label}</p>
                <p className="mt-1 text-2xl font-extrabold text-navy sm:text-3xl">{s.value}</p>
              </div>
            ))}
          </div>
        </StaggerItem>
      </div>

      {/* ---------------- SLIDING IMAGE REEL ---------------- */}
      <StaggerItem index={4}>
        <div className="relative mt-12 sm:mt-14">
          <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-10 bg-gradient-to-r from-slate-200 to-transparent sm:w-20" />
          <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-10 bg-gradient-to-l from-slate-200 to-transparent sm:w-20" />
          <div className="overflow-hidden">
            <div
              className="marquee-track gap-4 sm:gap-5"
              style={{ animationDuration: `${cat.images.length * 6}s` }}
            >
              {[...cat.images, ...cat.images].map((img, i) => (
                <ImageTile key={i} src={img} alt={`${cat.tag} ${(i % cat.images.length) + 1}`} />
              ))}
            </div>
          </div>
        </div>
      </StaggerItem>

      {/* ---------------- CTA ---------------- */}
      <StaggerItem index={5}>
        <div className="relative mt-10 text-center sm:mt-12">
          <Link
            to={cat.href}
            className="group inline-flex items-center gap-2 rounded-full bg-navy px-6 py-3 text-sm font-bold uppercase tracking-wide text-white transition hover:-translate-y-0.5 hover:bg-brand-orange"
          >
            Explore {cat.tag}
            <FiArrowUpRight className="transition duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </StaggerItem>
    </div>
  );
}

export default function CategoryReel() {
  return (
    <div>
      <div className="mx-auto max-w-7xl px-4 pt-16 text-center sm:px-6 lg:px-8">
        {/* Main Heading */}
        <h2 className="text-4xl font-extrabold uppercase leading-none sm:text-5xl lg:text-6xl">
          <span className="hero-shimmer block text-brand-orange">
            OUR PRODUCTS
          </span>
        </h2>

        {/* Secondary Heading */}
        <h3 className="mx-auto mt-4 max-w-3xl text-2xl font-bold text-navy sm:text-3xl lg:text-4xl">
          Explore all Products & Solutions
        </h3>
      </div>

      <div className="mx-auto mt-10 max-w-7xl px-4 sm:px-6 lg:px-8">
        {categories.map((cat) => (
          <CategoryRow key={cat.index} cat={cat} />
        ))}
      </div>
    </div>
  );
}